import React, { Component } from 'react';
import { getTxt } from 'global/appGlobal';
import { withStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import { graphql, compose } from 'react-apollo';
import { AppBar } from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';
import { TextField } from '@material-ui/core';
import { MenuItem } from '@material-ui/core';
import * as Icon from '@material-ui/icons';
import { Checkbox } from '@material-ui/core';
import GridEx from 'components/form/GridEx';
import { Button } from '@material-ui/core';
import moment from 'moment';
import { Badge } from '@material-ui/core';
import { p } from 'components/form/Proto';
import DeleteIcon from '@material-ui/icons/Delete';
import $ from 'jquery';
import { IconButton } from '@material-ui/core';
import { TableCell } from '@material-ui/core';
import { HashRouter, BrowserRouter, Route, Link, withRouter } from 'react-router-dom';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@material-ui/core';
import {
    SortingState, SelectionState, FilteringState, GroupingState,
    IntegratedFiltering, IntegratedGrouping, IntegratedSorting, IntegratedSelection,
} from '@devexpress/dx-react-grid';
import {
    Grid, Table,
    VirtualTable, TableHeaderRow, TableFilterRow, TableSelection, TableGroupRow,
    GroupingPanel, DragDropProvider, TableColumnReordering, Toolbar, TableColumnResizing,
} from '@devexpress/dx-react-grid-material-ui';
import LinearProgressEx from '../../components/LinearProgressEx';
import * as queries from '../../modules/publicInsType/publicInsTypeQueries';
import { getLabel, DictionaryTypes, removeDictionaryItem } from '../../global/dictionaryCache';
import PublicInsTypeEdit from '../../modules/publicInsType/PublicInsTypeEdit';
import { metadataQuery } from '../../home/Home';
import RegularCard from '../../components/dashboard/RegularCard';
import ComponentEx from '../../components/ComponentEx';
import { tableMessages, createGridResizerCols } from '../../global/appGlobal';




const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        margin: theme.spacing.unit * 3,
    },
    rootAsChildControl: {
        backgroundColor: theme.palette.background.paper,
    },
    button: {
        marginRight: theme.spacing.unit,
    },

    badge: {
        margin: `0 ${theme.spacing.unit * 2}px`,
        marginTop: 0,

    },
    gridRoot: {
        height: '100%',
    },

    tableHeader: {
        backgroundColor: theme.palette.background.paper,
    }
});

class PublicInsTypeSearch extends ComponentEx {


    state = {
        delDlgOpen: false,
        delId: undefined,
    };

    componentDidMount() {
        $("table[class*='Table-headTable']").addClass(this.props.classes.tableHeader);
    }

    handleDelete() {

        this.props.deleteType({
            variables: { id: this.state.delId },
            refetchQueries: [
                {
                    query: queries.allTypesQuery,
                },
                {
                    query: metadataQuery,
                },
            ],
        }, this).then(
            () => {

                this.props.data.refetch();
            });

        this.setState({ delDlgOpen: false });

    }

    render() {

        const columns = [

            { name: 'public_ins_type_name', title: getTxt('User Ins. type Name') },
            { name: 'public_ins_type_cd', title: getTxt('Iser Ins. type Key') },
            { name: 'actual_ins_type_cd', title: getTxt('Actual Ins. type') },
            { name: 'public_ins_type_id', title: getTxt('Azioni', '#tx5433z') },

        ];

        createGridResizerCols(this.state, columns, {}, 250);

        const { classes } = this.props;
        const items = this.props.data.all_Public_Ins_TypesQuery ? this.props.data.all_Public_Ins_TypesQuery : [];

        return (

            <div className={this.props.noAddBtn ? classes.rootAsChildControl : classes.root}>
                <LinearProgressEx loading={this.props.data.loading} />
                {!this.props.noCaption && <RegularCard

                    headerColor="red"
                    cardTitle={getTxt('User Ins. Types')}
                    cardSubtitle={getTxt('List of user Ins. Types')}
                    content={
                        <div>
                            {!this.props.noAddBtn && <Button color="primary" className={classes.button}

                                onClick={() => { this.setState({ editId: 'new' }); }}
                            >{getTxt('Aggiungi nuova Insurance Type')} </Button>}
                        </div>

                    }
                />}

                {this.props.addButton &&
                    <Button color="primary"
                        className={classes.button}

                        onClick={() => { this.setState({ editId: 'new' }); }}
                    >{getTxt('Aggiungi nuova Insurance Type')} </Button>
                }



                {
                    this.state.editId &&
                    <PublicInsTypeEdit
                        id={this.state.editId}
                        realType={this.props.realType}
                        AfterSubmit={((id) => {
                            this.setState({ editId: undefined });
                            this.props.data.refetch();
                            if (!this.props.realType && id) {
                                this.props.history.push(`/public_ins_type/view/${id}`);
                            }

                        })}

                    />
                }

                <Grid

                    rows={items}
                    columns={columns}

                >

                    <SortingState
                        defaultSorting={[{ columnName: 'public_ins_type_name', direction: 'asc' }]}
                    />


                    <IntegratedSorting />

                    <Table
                        messages={tableMessages}
                        cellComponent={({ row, column, style, ...props }) => {
                            if (column.name === 'public_ins_type_name') {
                                return (<Table.Cell>
                                    <Link to={`/public_ins_type/view/${row.public_ins_type_id}`} >{row.public_ins_type_name}</Link>
                                </Table.Cell>);
                            }
                            if (column.name === 'actual_ins_type_cd') {
                                return (
                                    <Table.Cell>
                                        {getLabel(DictionaryTypes.InternalInsuranceType, row.actual_ins_type_cd)}
                                    </Table.Cell>);
                            }
                            if (column.name === 'public_ins_type_id') {
                                return (<Table.Cell>

                                    <IconButton size="small" onClick={() => { this.setState({ delDlgOpen: true, delId: row.public_ins_type_id, delCd: row.public_ins_type_cd }); }} className={classes.inGridButton} >
                                        <DeleteIcon />
                                    </IconButton>


                                </Table.Cell>);
                            }
                            return <Table.Cell {...props} />;
                        }}
                    />

                    <TableColumnResizing
                        columnWidths={this.state.columnWidths}
                        onColumnWidthsChange={(cols) => { this.setState({ columnWidths: cols }); }}
                        defaultColumnWidths={this.state.defColumnWidths}
                    />
                    <TableHeaderRow showSortingControls />

                </Grid>
                <Dialog onClose={() => { this.setState({ delDlgOpen: false }); }} open={this.state.delDlgOpen}>
                    <DialogTitle >{getTxt('Elimina Ramo Personalizzato.')}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <span> {getTxt('Il ramo sarà cancellato sul server.')} </span>
                            <br />
                            <span > {getTxt('Sei sicuro di voler cancellare il ramo?')} </span>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.handleDelete(this.state.delId)} color="primary">
                            Ok
                        </Button>
                        <Button onClick={() => { this.setState({ delDlgOpen: false }); }} color="primary">
                            Annula
                        </Button>

                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default compose(

    graphql(queries.allTypesQuery, {
        options: props => (
            {
                realType: props.realTypeId,
                fetchPolicy: 'network-only',
                errorPolicy: 'all',
            }
        ),

    }),

    graphql(queries.deleteTypeMutation, {
        name: 'deleteType',
        options: {
            errorPolicy: 'all',
        },
    }),

)(withRouter(withStyles(styles)(PublicInsTypeSearch)));
